// mutations.js

export default {
    updatePortList(state, ports){
        state.portList = ports
    },
};
